import React from 'react';
import CookieCenterLink from './CookieCenterLink';
const FooterItemCustom = (props) => {
    const type = props.data.type.toLowerCase().replace(/ /g, '_');
    const isCookie = type === 'cookie_center_link';
    let options = {
        cookiepage: props.custom.cookieurl,
    };
    let optionsString = JSON.stringify(options);
    const urlMap = {
        login_registration_link: props.custom.loginurl,
        my_area_link: props.custom.accounturl,
    };
    return (React.createElement(React.Fragment, null, isCookie ? (React.createElement(CookieCenterLink, { options: optionsString, title: props.data.title, analytics: `{"event": "footer","eventCategory": "footer","eventAction": "${props.data.title_analytics || props.data.title}"}` })) : (React.createElement("a", { href: urlMap[type], "data-title-analytics": props.data.titleanalytics || props.data.title, className: "footer-menu__section__menuitem" }, props.data.title))));
};
export default FooterItemCustom;
